import { createSelector } from 'reselect';
import { mergeWith, isEmpty } from 'lodash';

const getRequestUpdate = state => state.requestUpdate.currentRequest;
const getTcEvent = state => state.tcEvent.currentEvent;
const getCapacityTypes = state => state.statics.capacityTypes;

export const getDefaultEventUpdate = (tcEvent) => {
  return {
    message: tcEvent.message || '',
    shippingAddress: {
      shipToName:  tcEvent.shipName || '',
      address1: tcEvent.shipAddress1 || '',
      address2:  tcEvent.shipAddress2 || '',
      address3: tcEvent.shipAddress3 || '',
      city:  tcEvent.shipCity || '',
      stateCode:  tcEvent.shipStateCode || '',
      postalCode: tcEvent.shipPostalCode || '',
      notes: "",
    },
    locationEvents: [],
  }
};

const customMergeFunction = (objValue, srcValue) => {
  if(srcValue === "" || isEmpty(srcValue)) {
    return objValue;
  }
};

export const mapEventUpdate = createSelector(
  [getRequestUpdate, getTcEvent],
  (requestUpdate, tcEvent) => {
    const defaultEventUpdate = {...getDefaultEventUpdate(tcEvent)};

    return requestUpdate.data ?
      (requestUpdate.data.eventUpdate ? mergeWith(defaultEventUpdate, requestUpdate.data.eventUpdate) : {}) : {...defaultEventUpdate};
  }
);

export const mapEventReschedule = createSelector(
  [getRequestUpdate],
  (requestUpdate) => {
    const defaultEventReschedule = {
      reason: '',
      dates: '',
    };

    return requestUpdate && requestUpdate.data &&
      requestUpdate.data.eventReschedule ? {...defaultEventReschedule,...requestUpdate.data.eventReschedule} : {...defaultEventReschedule}
  }
);

export const filterCapacityTypesByUnlimited = createSelector(
  [getCapacityTypes],
  (capacityTypes) => capacityTypes.filter(type => !type.unlimitedCapacityFlag)
)